import { useEffect, useLayoutEffect, useRef } from 'react';
import { useActiveDrag } from './DragDropProvider';

const EXPAND_DELAY_MS = 500;

interface UseExpandOnHoverArgs {
  isOver: boolean;
  isOpen: boolean;
  onExpand: () => void;
}

export const useExpandOnHover = ({
  isOver,
  isOpen,
  onExpand,
}: UseExpandOnHoverArgs): void => {
  const isDragging = !!useActiveDrag();
  const isOverRef = useRef(isOver);
  const isDraggingRef = useRef(isDragging);
  const onExpandRef = useRef(onExpand);

  useLayoutEffect(() => {
    isOverRef.current = isOver;
    isDraggingRef.current = isDragging;
    onExpandRef.current = onExpand;
  }, [isOver, isDragging, onExpand]);

  useEffect(() => {
    if (!isDragging) return;
    if (!isOver) return;
    if (isOpen) return;
    const timer = window.setTimeout(() => {
      if (isOverRef.current && isDraggingRef.current) {
        onExpandRef.current();
      }
    }, EXPAND_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, [isDragging, isOver, isOpen]);
};
